<!-- breadcrumb -->
<!-- <sv-breadcrumb></sv-breadcrumb> -->

<!-- shortcuts -->
<!-- <sv-shortcut-grid></sv-shortcut-grid> -->

<!-- products search view -->
<div class="search">
  <div class="row">
    <div class="col-12">
      <!-- this is search page  -->
      <sv-product-grid searchPage="true"></sv-product-grid>
    </div>
  </div>
</div>
